import i18n from 'i18n'

export const INITIAL_STATE_FORM = {
  end: null,
  start: null,
  typeDate: 'dtEmitted',
  status: 'all',
  acronym: '',
  page: 0,
  limit: 10
}

export const INITIAL_STATE_FORM_ERROR = {
  end: null,
  start: null,
  typeDate: '',
  status: '',
  acronym: '',
  page: 0,
  limit: 10
}

export const INITIAL_STATE_DETAILS = {
  id: '',
  companyId: '',
  fileId: '',
  logoId: '',
  name: '',
  acronym: '',
  number: '',
  dtEmitted: '',
  dtExpiry: '',
  nameCertifier: '',
  company: {
    id: '',
    city: '',
    cnpj: '',
    inspectionNum: '',
    name: '',
    state: '',
    status: null,
    photos: [
      {
        file: {
          src: ''
        }
      }
    ]
  },
  file: { src: '' },
  logo: { src: '' },
  status: null
}

export const typesDate = () => [
  { title: i18n.t('common:emited'), value: 'dtEmitted' },
  { title: i18n.t('common:expiry'), value: 'dtExpiry' }
]

export const status = () => [
  { title: i18n.t('indCertifications:active'), value: 'true' },
  { title: i18n.t('indCertifications:inactive'), value: 'false' },
  { title: i18n.t('common:all'), value: 'all' }
]
